import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkText } from 'uitk-react-text';
import { UitkSelect } from 'uitk-react-select';
import * as fetch from 'isomorphic-fetch';

export interface LinkSettingsFormProps {
  onLanguageSelectChange(event: any): void;
  selectedLanguage: string;
  onTrackingSelectChange(event: any): void;
  selectedTrackingChannel: string;
  renderElement(): any;
}
export interface IposList {
  id: number;
  countryCode: string;
  brand: string;
  isSelected: boolean;
}
export class LinkSettingsForm extends React.Component<LinkSettingsFormProps> {
  public constructor(props) {
    super(props);
  }

  public populateLanguages() {
    const languages = [
      { key: 'English', value: 1033 },
      { key: 'Espanol', value: 2058 },
      { key: 'Chinese', value: 2052 },
    ];

    return languages.map((lang) => {
      return (
        <option key={lang.key} value={lang.value}>
          {lang.key}
        </option>
      );
    });
  }

  public render() {
    const { onLanguageSelectChange, onTrackingSelectChange, renderElement } = this.props;

    return (
      <div className="uitk-grid dlb-border-line all-y-margin-six">
        <div className="uitk-flex dlb-link-settings-flex">
          <h3> Link Settings </h3>
        </div>
        <div className="uitk-cell all-x-padding-three">
          <form>
            <div className="uitk-grid all-b-margin-three">
              <div className="uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
                <UitkText align="left" size={300} weight="bold">
                  Landing Page Language*
                </UitkText>
                <UitkSelect id="language" label="Select Language" onChange={onLanguageSelectChange}>
                  {this.populateLanguages()}
                </UitkSelect>
              </div>
            </div>
            <div className="uitk-grid all-b-margin-three">
              <div className="uitk-cell s-cell-1-1 m-cell-1-4 l-cell-1-4 xl-cell-1-4">
                <UitkText align="left" size={300} weight="bold">
                  Tracking*
                </UitkText>
                <UitkSelect id="tracking" label="Select Tracking channel" onChange={onTrackingSelectChange}>
                  <option key="PHG" value="PHG">
                    PHG
                  </option>
                  <option key="CJ" value="Commission Junction">
                    Commision Junction
                  </option>
                </UitkSelect>
              </div>
            </div>
            {renderElement()}
          </form>
        </div>
      </div>
    );
  }
}
